module.exports = __webpack_public_path__ + "static/media/Foto 1 Santiago de Pachas_Foto Rufino Motta.20b78875.jpg";